import { Dispatch, SetStateAction, useEffect } from 'react';
import { LocationState } from 'contexts/LocationContext';
import { Invoice } from 'svg';
import { HEATMAP_FILTER_VALUE } from 'utils/map';
import { formatNumber } from 'utils/number';
import { FunFacts } from '..';

const HEATMAP_OPTIONS = [
  {
    display: 'Number of loans',
    value: HEATMAP_FILTER_VALUE.numberOfLoans
  },
  {
    display: 'Total loan amount',
    value: HEATMAP_FILTER_VALUE.totalLoanAmount
  },
  {
    display: 'Average loan amount',
    value: HEATMAP_FILTER_VALUE.averageLoanAmount
  }
];

type LoansPanelProps = {
  funFacts: FunFacts;
  setHeatMapFilter: (filter: string) => void;
  setLocation: Dispatch<SetStateAction<LocationState>>;
  onClose: () => void;
};

export default function LoansPanel({
  funFacts,
  setHeatMapFilter,
  setLocation,
  onClose
}: LoansPanelProps) {
  // set default option
  useEffect(() => {
    setHeatMapFilter(HEATMAP_OPTIONS[0].value);
  }, [setHeatMapFilter]);

  return (
    <div
      id="map-info-panel-loans-panel"
      className="map-info-panel"
      aria-labelledby="map-info-panel-loans-heading"
      role="dialog"
    >
      <div className="bg-secondary p-4 text-white">
        <a
          href="javascript:void(0);"
          className="text-xs font-bold text-end underline underline-offset-2"
          onClick={onClose}
        >
          Close
        </a>
        <h4 id="map-info-panel-loans-heading" className="h5 mt-4 text-white">
          Loans
        </h4>
      </div>
      <div className="map-info-panel-scroll">
        <div className="info-panel-child-sub-container">
          <p className="text-sm font-bold">Show heatmap for</p>
          <select
            name="loans-input-selector"
            id="loans-input-selector"
            className="info-panel-child-input-selector"
            onChange={(e) => setHeatMapFilter(e.target.value)}
            autoFocus
          >
            {HEATMAP_OPTIONS.map((option) => (
              <option key={option.display} value={option.value}>
                {option.display}
              </option>
            ))}
          </select>
          <div className="info-panel-child-gradient-progress-bar" />
          <div className="flexrow justify-between">
            <p className="text-xs uppercase">fewest</p>
            <p className="text-xs uppercase">most</p>
          </div>
        </div>
        <div className="info-panel-child-fun-facts-container">
          <div className="text-sm font-bold">Fun facts</div>
          {funFacts.highestNumberOfLoansLocation && (
            <div className="iconned-row flexrow">
              <Invoice />
              <div>
                <a
                  href="javascript:void(0);"
                  className="text-sm link-text-redirect"
                  onClick={() =>
                    setLocation(funFacts.highestNumberOfLoansLocation)
                  }
                >
                  {funFacts.highestNumberOfLoansLocation.location}
                </a>
                <span className="text-sm">
                  &nbsp;has the highest number of loans (
                  {funFacts.highestNumberOfLoansValue}).
                </span>
              </div>
            </div>
          )}

          {funFacts.highestTotalLoanAmountLocation && (
            <div className="iconned-row flexrow">
              <Invoice />
              <div>
                <a
                  href="javascript:void(0);"
                  className="text-sm link-text-redirect"
                  onClick={() =>
                    setLocation(funFacts.highestTotalLoanAmountLocation)
                  }
                >
                  {funFacts.highestTotalLoanAmountLocation.location}
                </a>
                <span className="text-sm">
                  &nbsp;has the highest total loan amount (
                  {formatNumber(
                    funFacts.highestTotalLoanAmountValue,
                    'currency'
                  )}
                  ).
                </span>
              </div>
            </div>
          )}

          {funFacts.highestAvgLoanAmountLocation && (
            <div className="iconned-row flexrow">
              <Invoice />
              <div>
                <a
                  href="javascript:void(0);"
                  className="text-sm link-text-redirect"
                  onClick={() =>
                    setLocation(funFacts.highestAvgLoanAmountLocation)
                  }
                >
                  {funFacts.highestAvgLoanAmountLocation.location}
                </a>
                <span className="text-sm">
                  &nbsp;has the highest avg. loan amount (
                  {formatNumber(funFacts.highestAvgLoanAmountValue, 'currency')}
                  ).
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
